import { Component, OnInit, Input } from '@angular/core';
import { SelectOption } from '@/shared/select/select.component.interface';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-contract-select',
  templateUrl: './contract-select.component.html',
  styleUrls: ['./contract-select.component.css'],
})
export class ContractSelectComponent implements OnInit {
  @Input() controlForm: FormControl = new FormControl();
  @Input() options: SelectOption[] = [];
  showTooltip: boolean = true
  constructor() { }

  ngOnInit(): void {
  }

}
